import React from "react";
import { Tooltip as MUITooltip } from "@mui/material";
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import { styled } from '@mui/material/styles';
import { type OverridableComponent } from "@mui/material/OverridableComponent";
import type { SvgIconTypeMap } from "@mui/material/SvgIcon";

type Props = {
    text?: string|null
    icon?: OverridableComponent<SvgIconTypeMap>
};

const Tooltip: React.FC<Props> = ({ text = "More information", icon = QuestionMarkRoundedIcon }) => {
    const StyledIcon = styled(icon)(({ theme }) => ({
        backgroundColor: theme.palette.info.main,
        borderRadius: 50,
    }));

    return (
        <MUITooltip
            title={text}
            enterTouchDelay={100}
            leaveTouchDelay={2000}
            slotProps={{ tooltip: { sx: { fontSize: '1rem' } } }}
        >
            <StyledIcon htmlColor={'white'} sx={{
                position: "absolute",
                mx: 1,
                p: '2px',
                fontSize: '1rem',
            }} />
        </MUITooltip>
    );
};

export default Tooltip;